import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { CheckResponse } from "@/types";

import { INITIAL_APP_STATE } from "./data";

const app = createSlice({
  name: "app",
  initialState: INITIAL_APP_STATE,
  reducers: {
    setBootstrap(state, action: PayloadAction<CheckResponse>) {
      state.bootstrap = action.payload;
    },
  },
});

export default app.reducer;

export const { setBootstrap } = app.actions;
